import React from 'react';
import SkeletonBlock from './SkeletonBlock';

export default function FormSkeleton({
  fields = 6,
  showAvatar = true,
  label = 'Loading',
  className = '',
}) {
  return (
    <div className={`sk-host sk-form ${className}`.trim()} role="status" aria-busy="true" aria-label={label}>
      <div className="sk-form__header">
        {showAvatar ? <SkeletonBlock variant="circle" width={72} height={72} /> : null}
        <div className="sk-form__header-text">
          <SkeletonBlock width="42%" height={18} />
          <SkeletonBlock width="28%" height={12} />
        </div>
      </div>
      <div className="sk-form__fields">
        {Array.from({ length: fields }, (_, index) => (
          <div className="sk-form__field" key={index}>
            <SkeletonBlock width="18%" height={10} />
            <SkeletonBlock width="100%" height={40} />
          </div>
        ))}
      </div>
    </div>
  );
}
